import { LoadingItem } from "./styles";

const Loading = () => {
  return <LoadingItem />;
};

export default Loading;
